<template>
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card m-b-30">
          <div class="card-header">
            <h3 class="card-title">Confirmación de compra</h3>
          </div>
          <div class="cart-body">
            <div class="row mb-4 mt-3">
              <div class="col-md-12 order-1 order-lg-2 col-lg-6">
                <div class="order-total table-responsive ">
                  <table class="table table-borderless text-center">
                      <tbody>
                        <tr>
                            <td class="f-w-7 font-16"><h6>Fecha entrega:</h6></td>
                            <td class="badge badge-primary-inverse font-18"><h4>{{deliveryDate}}</h4></td>
                        </tr>
                        <br/>
                        <tr>
                            <td class="f-w-7 font-16"><h6>Metodo de pago:</h6></td>
                            <select class="form-control form-control-mid" v-model="currentPaymentMethod">
                                <option value="01">Efectivo</option>
                                <option value="04">Tarjeta de crédito</option>
                                <option value="03">Transferencia bancaria</option>                         
                            </select>
                        </tr>
                        <tr>
                            <td class="f-w-7 font-16"><h6>Factura requerida?</h6></td>
                            <select class="form-control form-control-mid" v-model="currentInvoiceRequired">
                                <option value="true">Sí</option>
                                <option value="false">No</option>
                            </select>
                        </tr>
                        <!-- <tr>
                            <td>Subtotal: </td>
                            <td>{{explicitMoneyFormat(subtotalAndIeps)}}</td>
                        </tr> -->
                        <tr>
                            <td>IVA: </td>
                            <td>{{explicitMoneyFormat(ivaOrder)}}</td>
                        </tr>
                        <tr>
                            <td>IEPS: </td>
                            <td>{{explicitMoneyFormat(ieps)}}</td>
                        </tr>
                        <tr>
                            <td>Descuentos: </td>
                            <td>{{explicitMoneyFormat(discounts)}}</td>
                        </tr>
                        <tr>
                            <td class="f-w-7 font-18"><h4>Total:</h4></td>
                            <td class="f-w-7 font-18"><h4>{{explicitMoneyFormat(total)}}</h4></td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                <div class="cart-footer text-center" style="margin: 1% 5% 1% 5%">
                    <button type="button" class="btn btn-primary-rgba my-1 mr-2" @click.stop="goToShoppingCart" ><i class="feather icon-shopping-bag mr-2"></i>Regresar al carrito</button>
                    <!--router-link :to="{name: 'ticket'}" class="btn btn-success-rgba my-1 ml-2" @click.stop="executePurchase" >Confirmar compra<i class="feather icon-send ml-2"></i></router-link-->
                    <button class="btn btn-success-rgba my-1 ml-2" @click.stop="executePurchase" >Confirmar compra<i class="feather icon-send ml-2"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapMutations, mapState, mapGetters} from "vuex";
import formatHelper from "@mixins/formatHelper"
import dateHelper from "@mixins/dateHelper"
export default {
   name: "CheckoutPage",
   mixins: [formatHelper, dateHelper],
   data(){
      return {
         thumbnailUrl: "https://i.ibb.co/TcVZypR/mini-product.png",
         completed: false,
         currentPaymentMethod: '01',
         currentInvoiceRequired: false
      }
   },
   computed: {
      ...mapState("cart", ["order_notes", "order_details", "amounts", "promo_amounts", "promotion_details"]),
      ...mapState("auth", ["user", "is_logged"]),
      ...mapGetters("cart", ["getOrderNotes"]),
      deliveryDate(){
        return this.calculateDeliveryDate()
      },
      subtotal(){
        return this.amounts.after_tax_total + this.promo_amounts.after_tax_total
      },
      subtotalNoTaxes(){
        return this.amounts.subtotal + this.promo_amounts.subtotal_order_lines
      },
      subtotalAndIeps(){
        return (this.amounts.subtotal + this.amounts.ieps) + (this.promo_amounts.subtotal_order_lines + this.promo_amounts.ieps)
      },
      ieps(){
        return this.amounts.ieps + this.promo_amounts.ieps
      },
      ivaOrder(){

        var totalIVA = 0
        var totalIVAOrders = 0
        var totalIVAPromos = 0

        this.order_details.forEach(odt => {
            totalIVAOrders+= odt.iva
        });

        this.promotion_details.forEach(pdt => {
          pdt.order_details.forEach(odt => {
            totalIVAPromos+= odt.iva
          });
        });
        totalIVA = totalIVAOrders + totalIVAPromos
        return totalIVA
      },
      discounts(){
        return this.amounts.discount + this.promo_amounts.discount
      },
      total(){
        return this.subtotal - this.discounts
      },
   },
   methods: {
     ...mapMutations("cart", ["cleanCart"]),
      async goToShoppingCart(){
         await this.$router.push({name: "cart"})
      },
      calculateDeliveryDate(){

    
        // Fecha de entrega
        var fecha_entrega = new Date();

        // Se obtiene listado de días visita
        var fecha_hoy = new Date();

var diasSemana = {
    "DOMINGO": 0,
    "LUNES": 1,
    "MARTES": 2,
    "MIERCOLES": 3,
    "MIÉRCOLES": 3,
    "JUEVES": 4,
    "VIERNES": 5,
    "SABADO": 6,
    "SÁBADO": 6
};

// Ejemplo:
// "LUNES,JUEVES"
var dias_visita = this.user.Dia_visita
    .split(',')
    .map(dia => dia.trim().toUpperCase());

var dia_actual = fecha_hoy.getDay();

var menor_diferencia = 7;
var fecha_visita = null;

// Buscar la PRÓXIMA visita
dias_visita.forEach(dia => {
  
    var dia_visita = diasSemana[dia];

    if (dia_visita === undefined) {
        return;
    }

    var diferencia = (dia_visita - dia_actual + 7) % 7;

    // Si la visita es HOY, debe considerarse para la siguiente semana
    if (diferencia === 0) {
        //diferencia = 7;
    }

    if (diferencia <= menor_diferencia) {
        menor_diferencia = diferencia;

        fecha_visita = new Date(fecha_hoy);
        fecha_visita.setDate(
            fecha_visita.getDate() + diferencia
        );
    }
});

// La entrega es el día siguiente a la visita
var fecha_entrega = new Date(fecha_visita);
fecha_entrega.setDate(fecha_entrega.getDate() + 1);

if (fecha_entrega.getDay() === 0) {
    fecha_entrega.setDate(fecha_entrega.getDate() + 1);
}

        //fecha_entrega.setDate(fecha_entrega.getDate() + 7);

      /*// Si no tiene dias visita, se pone una semana después la entrega
        if (dias_visita == null || dias_visita == ''){

          fecha_entrega.setDate(fecha_entrega.getDate() + 7);

        // Si tiene dias visita, se obtienen y se calcula fecha de entrega
        }else{        

          // Lista de dias visita
          const dias_visita_list = this.user.Dia_visita.split(",");
          // Array para numeros de dia
          var dias_semana = [];

          // Se recorren dias visita para obtener su número de día
          for (var i=0; i < dias_visita_list.length; i++) {
              // Se obtiene número de día y se agrega en array
              dias_semana[i] = this.getDayWeek(dias_visita_list[i]);
          }
          // Se ordenan dias visita de menor a mayor
          dias_semana.sort(function(a,b){return a - b;});

          // Número de dia de la semana más cercano
          var day_close = dias_semana[0];

          // Se obtiene fecha y número de día de última visita
          var last_visit_date;
          var last_visit_number_day;
          const today = new Date();
          const last_visit = this.user.Fecha_ultima_visita

          if(last_visit != null){
              last_visit_date = new Date(last_visit);
          }else{
              last_visit_date = new Date();
          }
          last_visit_number_day = last_visit_date.getDay();

          // Se obtiene dias transcurridos desde la última fecha visita al dia de hoy
          var dias_transcurridos = this.diferenciaFechas(this.regularDateFormat(last_visit_date),this.regularDateFormat(today));

          // De acuerdo a la periodicidad se calcula la fecha entrega
          const periodicidad = this.user.Visita_dos_semanas     

          // Se calculan los dias
          var dias_entrega = 7;
          // Si coincide con la fecha actual
          if(this.regularDateFormat(today) == this.regularDateFormat(last_visit_date)){
              // Si es el mismo número de dia
              if(last_visit_number_day == today.getDay()){
                // Si tiene más de 1 dia configurado
                if(dias_semana.length > 1){
                    dias_entrega = dias_semana[1];
                }else{
                    // Si es QUINCENAL               
                    if(periodicidad == 1){
                      dias_entrega = 15-dias_transcurridos;
                    // Si es SEMANAL
                    }else if (periodicidad == 0){
                      dias_entrega = 8-dias_transcurridos;
                    }
                }
              }               
          }
          // Si no coincide con la fecha actual
          else{
              // Si es QUINCENAL               
              if(periodicidad == 1 || periodicidad){
                if(dias_transcurridos < 14){
                    dias_entrega = 14 - dias_transcurridos;
                }else{
                    dias_entrega = day_close;
                }
              // Si es SEMANAL
              }else if (periodicidad == 0 || !periodicidad){
                // Si el día más cercano ya pasó, se evalúa el siguiente
                if(last_visit_number_day == day_close){
                    if(dias_semana.length > 1){
                      dias_entrega = dias_semana[1]-1
                    }else{
                      dias_entrega = 7 - day_close;
                    }
                }else{
                    dias_entrega = day_close;
                }                  
              }
          }

          // Se asignan dias de entrega
          fecha_entrega.setDate(fecha_entrega.getDate() + (dias_entrega));
          // Si cae fecha en un dia visita configurado o en domingo, se agrega 1 dia
          if((dias_semana.indexOf(fecha_entrega.getDay()) != -1) || (fecha_entrega.getDay() == 0)){
            fecha_entrega.setDate(fecha_entrega.getDate() + 1);
            // Si la nueva fecha es domingo
            if(fecha_entrega.getDay() == 0){
              fecha_entrega.setDate(fecha_entrega.getDate() + 1);
            }
          }   
        } */
        return fecha_entrega.toLocaleDateString("en-GB")
      },
      async executePurchase(){
        this.showLoader("Ejecutando compra...")

        // generar el payload
        let promociones_ordenes = []
        let descuentos_promos_ordenes = []
        let regalos_promos_ordenes = []
        let detalles_orden = []
        let orden = {}
        var totalImpgPromos = 0
        var totalIepsPromos = 0

        orden.Fecha_Entrega = this.calculateDeliveryDate()
        orden.Descuento = this.discounts
        orden.SubTotal = this.subtotalNoTaxes
        orden.Importe = this.subtotal

        this.order_details.forEach(odt => {
          const obj = {
            ID_Producto: odt.product_id,
            Piezas_Solicitadas: odt.pieces,
            Cajas_Solicitadas: odt.boxes,
            SubTotal: odt.subtotal,
            ImpG: odt.iva,
            IEPS: odt.ieps,
            Importe: odt.cost,
            Descuento: odt.discount,
            Promocion_Indice: 0,
            ID_Promocion: null,
          }
          detalles_orden.push(obj)
        });

        this.promotion_details.forEach(pdt => {
          pdt.order_details.forEach(odt => {
            const obj = {
              ID_Producto: odt.product_id,
              Piezas_Solicitadas: odt.pieces,
              Cajas_Solicitadas: odt.boxes,
              SubTotal: odt.subtotal,
              ImpG: odt.iva,
              IEPS: odt.ieps,
              Importe: odt.cost,
              Descuento: odt.discount,
              Promocion_Indice: 1,
              ID_Promocion: pdt.promotion_id,
            }

            totalImpgPromos += odt.iva
            totalIepsPromos += odt.ieps

            detalles_orden.push(obj)

            if(odt.isGift){
              const gift = {
                ID_Producto: odt.product_id,
                ID_Promocion: pdt.promotion_id,
                Piezas_Configuradas: odt.pieces,
                Veces_Aplicada: pdt.quantity
              }
              regalos_promos_ordenes.push(gift)
            }
          });

          const prom = {
            ID_Promocion: pdt.promotion_id,
            Cantidad: pdt.quantity,
            Promocion_Indice: 1,
            Descuento: pdt.discount
          }
          promociones_ordenes.push(prom)
        });

        // Se agregan acumulados de ImpG e IEPS de promos
        //orden.ImpG = this.amounts.iva + totalImpgPromos
        orden.ImpG = this.subtotalAndIeps
        orden.IEPS = this.amounts.ieps + totalIepsPromos
        orden.IVA = this.ivaOrder
        
        orden.detalle_orden_attributes = detalles_orden
        orden.descuentos_promos_ordenes_attributes = descuentos_promos_ordenes
        orden.regalos_promos_ordenes_attribubtes = regalos_promos_ordenes
        orden.promociones_ordenes_attributes = promociones_ordenes

        const compraInfo = {
          //Notas: "Estas son notas de ejemplo"
          Notas: this.getOrderNotes,
          ID_Forma_Pago : this.currentPaymentMethod,
          IsFactura: this.currentInvoiceRequired
        }

        const payload = {
          Orden: orden,
          CompraInfo: compraInfo
        }

        const res = await this.xpost("/purchase", payload);
        this.stopLoader()
        if(res.success){
          this.completed = true
          // limpiar carro de compras
          this.cleanCart()
          const order_id = res.data.orden_id
          await this.$router.push({name: "ticket", params: { order_id: order_id }})
        }
        else {
          this.errorNotifDialog("Ha ocurrido un error con la compra", res.error)
        } 
      }
   }
}

</script>

<style>

</style>